import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "form", "spinner"]
  static values = { url: String }

  connect() {
    this.timeout = null
    this.lastQuery = this.inputTarget.value || ""
  }

  search(event) {
    // Clear existing timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    const query = this.inputTarget.value.trim()
    
    // Don't search if query is the same as last time
    if (query === this.lastQuery) {
      return
    }

    // Show spinner
    this.showSpinner()

    // Debounce the search - wait 300ms after user stops typing
    this.timeout = setTimeout(() => {
      this.performSearch(query)
    }, 300)
  }

  performSearch(query) {
    this.lastQuery = query
    
    // Submit the form (Turbo will handle the response)
    this.formTarget.requestSubmit()
    
    // Hide spinner after a short delay
    setTimeout(() => {
      this.hideSpinner()
    }, 500)
  }

  showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.style.display = 'flex'
    }
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.style.display = 'none'
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
}